import { render, staticRenderFns } from "./VDLCont.vue?vue&type=template&id=7e32e88b"
import script from "./VDLCont.vue?vue&type=script&lang=js"
export * from "./VDLCont.vue?vue&type=script&lang=js"
import style0 from "./VDLCont.vue?vue&type=style&index=0&id=7e32e88b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports